import type { SubjectEntity } from "../Processing/types";

/**
 * Resolve prefixed selection values to human-readable names.
 * Used by formStateToSpec to store names alongside IDs.
 *
 * Component-free on purpose: the slicer PDF snapshot and the headless renderer
 * read it without the antd form that also uses it.
 */
export function resolveSubjectNames(
  selectedSubjects: string[],
  selectedDrills: string[],
  getSubjectEntities: (t: string) => SubjectEntity[],
): string[] {
  const players = getSubjectEntities("player");
  const positions = getSubjectEntities("position");
  const drills = getSubjectEntities("drill");
  const groups = getSubjectEntities("group");

  const playerMap = new Map(players.map((p) => [`player-${p.id}`, p.name]));
  const posMap = new Map(positions.map((p) => [`pos-${p.id}`, p.name]));
  const drillMap = new Map(drills.map((d) => [`drill-${d.id}`, d.name]));
  const groupMap = new Map(groups.map((g) => [`group-${g.id}`, g.name]));

  const names: string[] = [];
  for (const val of selectedSubjects) {
    if (val === "full-team") names.push("Full Team");
    else names.push(playerMap.get(val) ?? posMap.get(val) ?? groupMap.get(val) ?? val);
  }
  for (const val of selectedDrills) {
    names.push(drillMap.get(val) ?? val);
  }
  return names;
}
